import { useTranslation } from 'react-i18next';
import { EntityDirectorySelectFilter } from '../shared/entityDirectory/EntityDirectorySelectFilter';
import {
  CustomerRoleFilterProps,
  useCustomerRoleFilter,
} from './hooks/useCustomerRoleFilter';

export function CustomerRoleFilter({
  value,
  onChange,
}: CustomerRoleFilterProps) {
  const { t } = useTranslation();
  const { options, selectedValue, onSelectedValueChange } =
    useCustomerRoleFilter({ value, onChange });

  return (
    <EntityDirectorySelectFilter
      options={options}
      placeholder={t('brandsDirectory.allRoles')}
      value={selectedValue}
      onChange={onSelectedValueChange}
    />
  );
}
